/*
 * @Author: yangecheng
 * @Date: 2025-05-29 13:05:56
 * @Description: 
 */
import React, { Component, Fragment } from 'react'
import { Button, Select, Form, Input, Row, Col, message, Popconfirm } from 'antd'
import './css/App2.css'
import './css/img.css'
import { getCamelChars, getFullChars } from './pinyin'
import moment from 'moment'
import cityBmArr from './config/bm' // 四川省城市代码

let Item = Form.Item
let options = [
  { value: '男', lable: '男' }, { value: '女', lable: '女' }
]

class App extends Component {

  formFef = React.createRef()

  state = {
    age: 18,
    sex: '男',
    zjhm: '*************',
    jsonText: '',
    mText: '',
    imgBase64_: undefined,
    hanzi:'',
    zimu:'',
  }

  UNSAFE_componentWillMount() {    
    // console.log('================================', getCamelChars('测试测试'))
    // this.getZjhm()
  }

  /* Unicode转码 */
  mTextChange =(e) => {
    let value = e.target.value
    this.setState({ mText: value })
  }


  getImageBase64 = async () => {
    let file = this.imgRef.files[0]
    if (!file) {
      message.warn('请上传图片')
      return
    }
    if (file?.type?.indexOf('image') > -1) {
      let reader0 = new FileReader()
      reader0.readAsDataURL(file)
      reader0.onload = async (e) => {
        let base64 = e.target.result
        // console.log('====================', base64)      
        await this.setState({ imgBase64: base64 })
      }
    }  
  }
  setImage = async () => {
    let file = this.imgRef.files[0]
    if (file?.type?.indexOf('image') > -1) {
      let reader0 = new FileReader()
      reader0.readAsDataURL(file)
      reader0.onload = async (e) => {
        let base64 = e.target.result
        // console.log('====================', base64)      
        await this.setState({ imgBase64_: base64, imgBase64: '' })
      }
    }
  }
  downloadtBase64Img = () => {
    if (this.state.imgBase64_) {
      // 创建隐藏的<a>元素
      const link = document.createElement('a');
      link.href = this.state.imgBase64_;  // 直接使用完整的base64数据
      link.download = 'base64转换图片'
      // 追加到body中，触发点击，然后移除
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  /* Base64转码 */
  base64Change = (e) => {
    let value = e.target.value
    this.setState({ imgBase64: value })
  }
  getImage = () => {
    let base64 = this.state.imgBase64
    if (!base64) {
      message.warn('请输入Base64')
      return
    }
    if (base64 && !base64.startsWith('data:image/')) {
      base64 = 'data:image/jpeg;base64,' + base64
    }
    this.setState({ imgBase64_: base64?.trim() })
  }

  /* 获取随机*** */
  ageChange = (e) => {
    let value = e.target.value
    this.setState({ age: value })
  }
  sexChange = (e) => {
    this.setState({ sex: e })
  }
  getZjhm = () => {
    // 1、前6位区域码随机生成
    let IdCard = cityBmArr[Math.floor(Math.random() * 20)]
    // 2、其后8位出生日期随机生成
    let age =  this.state.age && /^[0-9]+$/.test(this.state.age) ? Number(this.state.age) : 18
    let year = Number(moment().format('YYYY')) - age
    if (year < 1000) {
      year = 1000
      this.setState({ age: Number(moment().format('YYYY')) - year  })
    }
    // 随机生成0-11的数字
    const randomMonthNum = Math.floor(Math.random() * 11)
    // 随机生成1-30数字
    const randomDateNum = Math.ceil(Math.random() * 30)
    let randomDate = moment(year + '0101').month(randomMonthNum).date(randomDateNum).format('YYYYMMDD')
    IdCard += randomDate
    // 3、再其后2位随机码生成
    IdCard += '' + Math.floor(Math.random() * 10) + Math.floor(Math.random() * 10)
    // 4、再其后1位性别码生成（男为奇数、女为偶数）
    let sexBm = Math.floor(Math.random() * 10)
    if ('男' === this.state.sex) {
      if (sexBm % 2 === 0) {
        sexBm++
      }
    } else if ('女' === this.state.sex) {
      if (sexBm % 2 === 1) {
        sexBm--
      }
    }
    IdCard += '' + sexBm
    // 5、最后1位校验码生成
    let cs = IdCard.split('')
    // 加权因子wi
    let POWER_LIST = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
    // 校验码
    let PARITYBIT = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']
    let power = 0
    for (let i = 0; i < cs.length; i++) {// 循环比正则表达式更快
      power += (cs[i] - '0') * POWER_LIST[i]
    }
    IdCard += PARITYBIT[power % 11]

    this.setState({ zjhm: IdCard })
  }
  
  /* json格式化处理 */
  jsonChange = (v) => {
    this.setState({ jsonText: v.target.value })
  }
  jsonFormatDo = () => {
    let { jsonText } = this.state
    let json = jsonText
    try {
      json = this.formatJson(jsonText)
      if (json && json === jsonText && json.length > 2 && json.startsWith('"') && json.endsWith('"')) {
        let jsonText2 = jsonText?.replace(/\\"/g, '"')
        json = this.formatJson(jsonText2?.substring(1, jsonText2.length - 1))
      }
    } catch {
      if (jsonText.indexOf('{') === -1 && jsonText.indexOf('[')) {
        let objStr = ''
        let arr = jsonText.split('\n')
        for (let i = 0; i < arr.length; i++) {
          if (arr[i] && arr[i].trim()) {
            objStr += '  "' + arr[i] + '" : "",\n'
          }
        }
        if (objStr) {
          json = '{\n' + objStr.substring(0, objStr.length-2) + '\n}'
        }
      }
      message.warn('不是json格式')      
    }
    this.setState({ jsonText: json })
  }
  formatJson = (json) => {
    return JSON.stringify(JSON.parse(json),null,2)
  }

  render() {
    let { age, sex, zjhm } = this.state
    return (
      <Fragment>
        <Form /* ref={this.formFef} */ ref={c => this.form = c} style={{minHeight: '1800px'}}>

          <Item label='json格式化' style={{ marginBottom: '-15px', fontWeight: '600'}} />
          <Row gutter={0} type="flex" justify="left" align="top" style={{ marginLeft: '50px', marginTop: '20px' }}>
            <Col span={4}><Button type='primary' onClick={this.jsonFormatDo}>处理</Button></Col>
            <Col span={16}>
              <Item> 
                <Input.TextArea className='TextAreaP' style={{lineHeight: '1.2'}} spellCheck='false' value={this.state.jsonText} onChange={this.jsonChange} />
              </Item>
            </Col>
          </Row>
          <hr className='hr1'/>
          
          <Item label='字母大小写转换' style={{ marginBottom: '-15px', fontWeight: '600'}} />
          <Row gutter={0} type="flex" justify="left" align="top" style={{ marginLeft: '50px', marginTop: '20px' }}>
            <Col span={4}>
              <Button style={{ marginRight: '10px' }} type='primary' onClick={() => { this.setState({ zimu: this.state.zimu?.toUpperCase() }) }}>大写</Button>
              <Button type='primary' onClick={() => { this.setState({ zimu: this.state.zimu?.toLowerCase() }) }}>小写</Button>
            </Col>
            <Col span={16}>
              <Item>
                <Input.TextArea className='TextAreaP' style={{ lineHeight: '1.2' }} spellCheck='false' value={this.state.zimu} onChange={e => { this.setState({ zimu: e.target.value }) }} />
              </Item>
            </Col>
          </Row>
          <hr className='hr1'/> 

          <Item label='汉字转拼音' style={{ marginBottom: '-15px', fontWeight: '600'}} />
          <Row gutter={0} type="flex" justify="left" align="top" style={{ marginLeft: '50px', marginTop: '20px' }}>
            <Col span={4}>
              <Button style={{ marginRight: '10px' }} type='primary' onClick={() => { this.setState({ hanzi: getCamelChars(this.state.hanzi)?.toLowerCase() }) }}>首拼</Button>
              <Button type='primary' onClick={() => { this.setState({ hanzi: getFullChars(this.state.hanzi)?.toLowerCase() }) }}>全拼</Button>
            </Col>
            <Col span={16}>
              <Item>
                <Input.TextArea className='TextAreaP' style={{ lineHeight: '1.2' }} spellCheck='false' value={this.state.hanzi} onChange={e => { this.setState({ hanzi: e.target.value }) }} />
              </Item>
            </Col>
          </Row>
          <hr className='hr1'/>

          <Item label='随机****码' style={{ marginBottom: '-15px', fontWeight: '600'}} />
          <Row gutter={0} type="flex" justify="left" align="top" style={{ marginLeft: '50px', marginTop: '20px' }}>
            <Col span={4} style={{ display: 'flex' }}>
              <Input type='text' value={age} onChange={this.ageChange} style={{ marginRight: '10px', width: '50%' }} 
                suffix={<Select defaultValue={sex} options={options} onChange={this.sexChange} />}
              />
              <Button type='primary' style={{ alignSelf: 'center' }} onClick={this.getZjhm}>获取</Button>
            </Col>
            <Col span={5}>
              <Item> 
                <div width='100%' style={{textAlign: 'center', paddingTop: '10px'}}>{zjhm}</div>
                <hr className='hr2' />
              </Item>
            </Col>
          </Row>
          <hr className='hr1'/>   

          <Item label='Unicode转码' style={{ marginBottom: '-15px', fontWeight: '600'}} />
          <Row gutter={0} type="flex" justify="left" align="top" style={{ marginLeft: '50px', marginTop: '20px' }}>            
            <Col span={4}>
              <Button style={{ marginRight: '10px' }} type='primary' onClick={() => { this.setState({ mText: escape(this.state.mText) }) }}>编码</Button>
              <Button type='primary' onClick={() => { this.setState({ mText: unescape(this.state.mText.replaceAll('\\', '%')) }) }}>解码</Button></Col>
            <Col span={16}>
               <Item>
                <Input.TextArea className='TextAreaP' style={{ lineHeight: '1.2' }} spellCheck='false' value={this.state.mText} onChange={this.mTextChange} />
              </Item>
            </Col>
          </Row>
          <hr className='hr1' />

          <Item label='Base64图片转码' style={{ marginBottom: '-15px', fontWeight: '600'}} />
          <Row gutter={0} type="flex" justify="left" align="top" style={{ marginLeft: '50px', marginTop: '20px' }}>
            <Col span={4}>
              <Button style={{ marginRight: '10px', padding: '0 5px 0 5px' }} type='primary' onClick={this.getImage}>转图片</Button>
              <Button style={{ padding: '0 5px 0 5px' }} type='primary' onClick={this.getImageBase64}>转Base64</Button>
            </Col>
            <Col span={8}>
              <Item> 
                <Input.TextArea ref={(ref) => {this.textAreaRef = ref}} spellCheck='false' style={{height: '200px'}} value={this.state.imgBase64} onChange={this.base64Change} placeholder='输入Base64' />
              </Item>
            </Col>
            <Col span={8}>
              <div className='ImageUpload'>
                {this.state.imgBase64_ && <Popconfirm title="是否需要下载图片?" onConfirm={this.downloadtBase64Img} okText="确定"  cancelText="取消">
                  <img src={this.state.imgBase64_} width='100%' height='100%' style={{ objectFit: 'contain', position: 'absolute' }} alt='' />
                </Popconfirm>}
                <label className='upload ant-btn' style={{ display: 'inline' }}>
                  上传图片
                  <input ref={(ref) => { this.imgRef = ref }} className='sr-only' type='file' accept='image/*' onChange={this.setImage} />
                </label>
              </div>
            </Col>
          </Row>
          <hr className='hr1' style={{color: '#dddddd'}}/>          

        </Form> 
      </Fragment>
    )
  }
}

export default App
